import { GAEventNames } from "game/analytics/events";
import { GAEvent } from "game/analytics/events";
import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { useSelector } from "react-redux";
import { UIRootState } from "ui/store";
import { Popups, StoriesNoTicketsPopupData } from "ui/types/popups";

export const StoriesNoTicketsPopup = () => {

    const { storyId, imageIndex } = useSelector((state: UIRootState) => state.popups?.[Popups.STORIES_NO_TICKETS_POPUP]?.data as StoriesNoTicketsPopupData);
    
    const handleCloseBtnClick = () => {
        GAEvent(GAEventNames.STORIES_NO_TICKET_BANNER_CLOSE, {
            story_name: storyId,
            image_number: imageIndex,
        });
        GameUI.closePopup(Popups.STORIES_NO_TICKETS_POPUP);
    }

    const handleWatchAdBtnClick = () => {
        (window as any)?.dataLayer.push({
            event: "stories_no_ticket_banner_watch_ad",
            name: (window as any)?.currentStoryNumber,
            image_number: (window as any)?.currentNextStoryImageNumber,
        });
        GameUI.closePopup(Popups.STORIES_NO_TICKETS_POPUP);
    }

    const handlePlayBtnClick = () => {
        (window as any)?.dataLayer.push({
            event: "stories_no_ticket_banner_play",
            name: (window as any)?.currentStoryNumber,
            image_number: (window as any)?.currentNextStoryImageNumber,
        });
        GameUI.closePopup(Popups.STORIES_NO_TICKETS_POPUP);
    }

    return (
        <div id="stories_no_tickets" role="tooltip" className="magic_wand modals_area active">
            <div className="wrapper">
                <button id="closing-ignore-el" type="button" className="close_btn close" onClick={handleCloseBtnClick}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("stories_no_tickets_popup_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/stories_modals/stories_no_tickets.webp"  />
                    <p className="modals_area-text">{translate("stories_no_tickets_popup_text")}</p>
                    <div className="feedback_btn-wrap">
                        <button type="button" id="closing-ignore-el" className="discard_btn watch-ad-button d-flex align-items-center gap-1" onClick={handleWatchAdBtnClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M18 7.77273H2V14.9245C2 16.0708 2.89861 17 4.0071 17H15.9929C17.1014 17 18 16.0708 18 14.9245V7.77273ZM9.26453 9.12126C9.06218 8.9603 8.76923 9.10947 8.76923 9.37346V14.7231C8.76923 14.9939 9.0757 15.1409 9.27567 14.966L12.4782 12.1638C12.6279 12.0328 12.6225 11.7923 12.467 11.6687L9.26453 9.12126Z" fill="#149246"/>
                                <path d="M2 5.07552C2 3.92924 2.89861 3 4.0071 3H8.10705L5.07692 6.5H2V5.07552Z" fill="#149246"/>
                                <path d="M6.66218 6.5L9.69231 3H13.6455L10.6154 6.5H6.66218Z" fill="#149246"/>
                                <path d="M12.2006 6.5H18V5.07552C18 3.92924 17.1014 3 15.9929 3H15.2308L12.2006 6.5Z" fill="#149246"/>
                            </svg>
                            {translate("stories_no_tickets_popup_button_1")}
                        </button>
                        <a><button onClick={handlePlayBtnClick} type="button" id="closing-ignore-el" className="modals_area-btn play-button">{translate("stories_no_tickets_popup_button_2")}</button></a>
                    </div>
                </div>
            </div>
        </div>
    )
}